/**
 * Fødselsnummer on the person page (owner decision 2026-10-15; docs/platform-implementation/NATIONAL_ID.md): the words,
 * and when the card is drawn at all. Pure, so the panel test holds it without a browser.
 *
 * The card exists only when the mosque HAS the capability `national_id` (GET /mosque `capabilities`) and this staff
 * member holds `members.national_id` (admin, super admin). Otherwise nothing is drawn and nothing is asked — the server
 * would answer 403 or 404 capability_disabled anyway.
 */
export const NID_CAPABILITY = 'national_id';
export const NID_PERMISSION = 'members.national_id';

export const shows = (caps: string[] | null | undefined, can: (p: string) => boolean): boolean =>
  Boolean(caps && caps.includes(NID_CAPABILITY) && can(NID_PERMISSION));

export const SOURCE_NO: Record<string, string> = {
  applicant: 'oppgitt av søkeren', staff: 'ført inn av kontoret', bankid: 'fra BankID (bekreftet)',
};

/** How long a revealed number stays on the screen before it is masked again by itself. */
export const REVEAL_MS = 30_000;

/** What the field shows: the masked form from the server, or the revealed number while it is shown. Never stored. */
export function shown(status: { registered?: boolean; masked?: string } | null, revealed: string | null): string {
  if (!status || !status.registered) return 'Ikke registrert';
  return revealed || status.masked || '•••••• •••••';
}

/** Keep only digits, spaces, dots and hyphens while typing (the server checks the rest). At most 14 characters. */
export const typed = (v: string): string => v.replace(/[^\d .-]/g, '').slice(0, 14);
